<template>
  <div class="logout row align-center">
    <ViewHeader :hasBack="true" :title="$t('logout.title')" />
  </div>
</template>

<script src="./logout.js"></script>
